import React from "react";
import { Navigate } from "react-router-dom";
const AdminPublicRoute = ({ children }) => {
  
        const temp = localStorage.getItem("nameData");

        if (temp) {
            return <Navigate to="/admin/client-list" />;
        }
    

    return children;
};

export default AdminPublicRoute;
